import { BackendAPIConfig, AlbionIDSiteConfig } from '@/models/models'

/**
 * Environment
 * @type string
 */
export const env = 'development'

/**
 * BackendAPIConfig
 * @type string
 */
export const backendAPIConfig = new BackendAPIConfig({
    endpoint: 'https://membership.sub.r-aws.com/api'
})

/**
 * ALBION公式EC
 * albionOfficialEcSiteConfig
 * @type AlbionIDSiteConfig
 */
export const albionOfficialEcSiteConfig = new AlbionIDSiteConfig({
    siteUrl: 'https://hope.softcreate.co.jp/albion/site'
})

/**
 * LINE会員証
 * lineMembersCardSiteConfig
 * @type AlbionIDSiteConfig
 */
export const lineMembersCardSiteConfig = new AlbionIDSiteConfig({
    isUseMembersCard: true,
})

/**
 * ALBIONカード
 * albionCardEcSiteConfig
 * @type AlbionIDSiteConfig
 */
export const albionCardEcSiteConfig = new AlbionIDSiteConfig({})